module.exports = __webpack_public_path__ + "static/media/trolley.2c6d553b.svg";